import React, { useEffect, useState } from 'react';
import { auth, firestore } from '../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';

const AdminRoute = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          // Fetch user profile by email (not UID)
          const q = query(
            collection(firestore, 'UserProfileMaster'),
            where('email', '==', user.email)
          );
          const snap = await getDocs(q);
          if (!snap.empty) {
            const userProfileData = snap.docs[0].data();
            const { userGrpID, tenantID } = userProfileData;
            if (userGrpID && tenantID) {
              // Fetch user group from UserEmailGrpMaster
              const grpQ = query(
                collection(firestore, 'UserEmailGrpMaster'),
                where('tenantID', '==', tenantID),
                where('userGrpID', '==', userGrpID)
              );
              const grpSnap = await getDocs(grpQ);
              if (!grpSnap.empty) {
                const userGroup = grpSnap.docs[0].data();
                const rawRole = userGroup.userRole || '';
                const trimmedRole = rawRole.toString().trim().toLowerCase();
                sessionStorage.setItem('isAdmin', trimmedRole === 'admin');
                sessionStorage.setItem('isSuperAdmin', trimmedRole === 'superadmin');
              } else {
                sessionStorage.setItem('isAdmin', 'false');
                sessionStorage.setItem('isSuperAdmin', 'false');
              }
            } else {
              sessionStorage.setItem('isAdmin', 'false');
              sessionStorage.setItem('isSuperAdmin', 'false');
            }
          } else {
            sessionStorage.setItem('isAdmin', 'false');
            sessionStorage.setItem('isSuperAdmin', 'false');
          }
        } catch (err) {
          sessionStorage.setItem('isAdmin', 'false');
          sessionStorage.setItem('isSuperAdmin', 'false');
        }
      } else {
        sessionStorage.setItem('isAdmin', 'false');
        sessionStorage.setItem('isSuperAdmin', 'false');
      }
      setIsLoading(false);
    });
    return unsubscribe;
  }, []);

  const isAdmin = sessionStorage.getItem('isAdmin') === 'true' || sessionStorage.getItem('isSuperAdmin') === 'true';

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (!isAdmin) {
    return <div>You don't have admin rights</div>;
  }
  return children;
};

export default AdminRoute;
